import { ReactNode } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Button } from '@/components/ui/button'

interface TabConfig {
  value: string
  label: string
  buttonText: string
  content: ReactNode
}

interface SettingsPageLayoutProps {
  title: string
  tabs: TabConfig[]
  activeTab: string
  onTabChange: (value: string) => void
  onMainAction: () => void
}

export function SettingsPageLayout({
  title,
  tabs,
  activeTab,
  onTabChange,
  onMainAction,
}: SettingsPageLayoutProps) {
  const currentTab = tabs.find(tab => tab.value === activeTab)

  return (
    <div className="space-y-6 p-6 pt-0">
      <div className="mt-6">
        <PageHeader title={title} />
      </div>

      <Tabs value={activeTab} onValueChange={onTabChange}>
        <div className="space-y-4 lg:space-y-0">
          <div className="flex flex-col space-y-4 lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
            <TabsList className={`grid grid-cols-${tabs.length} mb-4 lg:mb-0`}>
              {tabs.map(tab => (
                <TabsTrigger key={tab.value} value={tab.value}>
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
            <div className="flex items-center gap-2">
              <Button onClick={onMainAction} variant="form">
                {currentTab?.buttonText}
              </Button>
            </div>
          </div>
        </div>

        {tabs.map(tab => (
          <TabsContent key={tab.value} value={tab.value} className="mt-6">
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  )
}
